import { useEffect } from 'react'

/**
 * SessionWarningModal -- Countdown warning shown before automatic session logout.
 *
 * LEGACY: slu-frontend/src/common/security/sessionWarning.tpl.html
 *
 * Displays a Bootstrap 3 modal with a countdown timer. The user can choose
 * to continue working (resets the session timeout) or log out immediately.
 *
 * This modal uses `backdrop: 'static'` behaviour (no close on backdrop click)
 * and `keyboard: false` behaviour (no close on Escape) to match the AngularJS
 * original. The user must explicitly click a button to dismiss it.
 */

export interface SessionWarningModalProps {
    show: boolean
    timeDisplay: string
    onContinue: () => void
    onLogout: () => void
}

export function SessionWarningModal({
    show,
    timeDisplay,
    onContinue,
    onLogout,
}: SessionWarningModalProps) {
    // Add/remove modal-open class on body for scroll locking
    useEffect(() => {
        if (show) {
            document.body.classList.add('modal-open')
        }
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [show])

    if (!show) return null

    return (
        <>
            <div className="aps-background-mask mask-is-active" />
            <div
                className="modal fade in session-warning-modal"
                style={{ display: 'block' }}
                role="dialog"
                tabIndex={-1}
                aria-labelledby="session-warning-title"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header session-warning-header">
                            <h3 className="modal-title session-warning-title" id="session-warning-title">
                                Still Working?
                            </h3>
                        </div>
                        <div className="modal-body session-warning-body">
                            <div className="session-warning-timer">
                                <span className="timer-display">{timeDisplay}</span>
                            </div>
                            <div className="session-warning-message">
                                <p>
                                    You'll be logged out once the timer reaches zero unless you
                                    choose to continue.
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer session-warning-footer">
                            <div className="aps-button-container">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={onContinue}
                                >
                                    CONTINUE WORKING
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={onLogout}
                                >
                                    LOG OUT NOW
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
